import Nav from "../component/nav/nav";
import "flowbite";
import { Select } from "antd";
import { useEffect, useRef, useState } from "react";
import {
  auth,
  db,
  onSnapshot,
  collection,
  onAuthStateChanged,
  doc,
  updateDoc,
} from "../config/firebase";
import { DropDownIcon } from "../utils/icons";
import StudentCount from "../component/studentcount";
import FirestoreToExcel from "../component/downloadData";
import TableAPP from "../component/table/table";
import { debounce } from "lodash";

function Admin() {
  const [data, setData] = useState([]);
  const actionRef = useRef(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const q = collection(db, "Students");
    onSnapshot(q, (snapshot) => {
      const newData = [];
      snapshot.forEach((doc) => {
        newData.push(doc.data());
      });
      console.log("newData", newData);
      setData(newData);
    });
  }, []);

  const handleStatusChange = debounce((status) => {
    setStatusFilter(status);
  }, 300);

  const handleSearchChange = debounce((e) => {
    setSearchQuery(e.target.value);
  }, 300);

  const handleActionClick = () => {};

  onAuthStateChanged(auth, (user) => {
    if (user) {
      setCurrentUser(user);
    } else {
      window.location.href = "../signIn";
    }
  });

  // const updateStatus = async (id) => {
  //   const pay = document.getElementById(id + "-admin");
  //   const washingtonRef = doc(db, "Students", id);
  //   await updateDoc(washingtonRef, {
  //     status: pay.value
  //   });
  //   alert("updated");
  // };

  return (
    <>
      <Nav></Nav>
      <div class="p-4 sm:ml-4 md:ml-64">
        <div class="p-4 border-2 border-gray-200 border-dashed rounded-lg dark:border-gray-700 mt-4">
          <StudentCount></StudentCount>

          <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
            <div class="flex items-center justify-between py-4 bg-white dark:bg-gray-800">
              <div className="w-96 flex justify-between">
                {/* <button
                  onClick={handleActionClick}
                  id="dropdownActionButton"
                  data-dropdown-toggle="dropdownAction"
                  class="inline-flex items-center text-gray-500 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-3 py-1.5 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                  type="button"
                >
                  <span class="sr-only">Action button</span>
                  Action
                  
                </button> */}
                <Select
                  suffixIcon={<DropDownIcon />}
                  placeholder="Select Status"
                  style={{ width: 120 }}
                  onChange={handleStatusChange}
                  options={[
                    { value: "Approved", label: "Approved" },
                    { value: "Pending", label: "Pending" },
                  ]}
                />

                <div>
                  <FirestoreToExcel></FirestoreToExcel>
                </div>
                {/* <div class="z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600">
                  <ul className="py-1 text-sm text-gray-700 dark:text-gray-200">
                    <li>
                      <a
                        href="#"
                        onClick={() => handleStatusChange("Approved")}
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Approved
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => handleStatusChange("Pending")}
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Pending
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
              <label for="table-search" class="sr-only">
                Search
              </label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg
                    class="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>

                <input
                  onChange={handleSearchChange}
                  type="text"
                  id="table-search-users"
                  class="block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Search for users"
                />
              </div>
            </div>

            <TableAPP statusFilter={statusFilter} searchQuery={searchQuery} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Admin;
